/* ==========================================================================
   Aural Spain — JavaScript del tema

   Cambios importantes respecto a la versión anterior:

   1. init() se volvía a ejecutar entero en cada `shopify:section:load` y volvía
      a enganchar los listeners globales. En el editor de temas eso hacía que un
      clic en «Añadir a la cesta» añadiera el producto dos o tres veces y que los
      acordeones se abrieran y cerraran en el mismo clic. Ahora los listeners de
      documento se enganchan una sola vez y cada elemento se marca como
      inicializado.
   2. La galería cambiaba `src` pero no `srcset`, así que en pantallas normales
      la foto grande no cambiaba al pulsar una miniatura. Ahora la galería es una
      pista con todos los medios y se desplaza, sin tocar atributos de imagen.
   3. Al cambiar de variante no pasaba nada con la foto. Ahora salta a la imagen
      de esa variante y actualiza referencia, título y barra fija.
   4. Los packs ponían la cantidad pero la cantidad no ponía el pack: si tocabas
      el selector de unidades, el pack marcado se quedaba mintiendo. Ahora van
      sincronizados en los dos sentidos.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || {};
  var strings = T.strings || {};
  var globalsBound = false;

  /* ------------------------------------------------------------- Utils -- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function once(el, key) {
    if (!el || el.dataset[key] === 'on') return false;
    el.dataset[key] = 'on';
    return true;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function formatMoney(cents, format) {
    var fmt = format || T.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents || 0) / 100;

    function withDelimiters(num, precision, thousands, decimal) {
      num = Math.abs(num).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return (cents < 0 ? '-' : '') + intPart + decPart;
    }

    if (/amount_no_decimals_with_comma_separator/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDelimiters(value, 0, '.', ','));
    }
    if (/amount_with_comma_separator/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDelimiters(value, 2, '.', ','));
    }
    if (/amount_with_apostrophe_separator/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withDelimiters(value, 2, "'", '.'));
    }
    if (/amount_no_decimals/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withDelimiters(value, 0, ',', '.'));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withDelimiters(value, 2, ',', '.'));
  }

  function toast(message) {
    var el = $('#Toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'Toast';
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  /* ------------------------------------------------- Barra de anuncios -- */

  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      // El intervalo anterior nunca se limpiaba: al recargar la sección en el
      // editor se acumulaban y los mensajes empezaban a parpadear.
      if (bar._rotator) clearInterval(bar._rotator);

      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;

      var delay = parseInt(bar.dataset.rotate || '4000', 10);
      var i = items.findIndex(function (el) { return el.classList.contains('is-active'); });
      if (i < 0) i = 0;

      bar._rotator = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ------------------------------------------------------ Cuenta atrás -- */

  var countdownTimer = null;

  function endOfToday() {
    var d = new Date();
    d.setHours(23, 59, 59, 999);
    return d;
  }

  function initCountdowns() {
    var nodes = $$('[data-countdown]');
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
    if (!nodes.length) return;

    function tick() {
      var now = Date.now();
      nodes.forEach(function (node) {
        var target;
        if (node.dataset.countdownEnd) {
          target = new Date(node.dataset.countdownEnd).getTime();
          if (isNaN(target)) target = endOfToday().getTime();
        } else {
          target = endOfToday().getTime();
        }

        var totalSeconds = Math.floor(Math.max(0, target - now) / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var mins = Math.floor((totalSeconds % 3600) / 60);
        var secs = totalSeconds % 60;

        var dEl = $('[data-unit="days"]', node);
        if (dEl) {
          dEl.textContent = String(days).padStart(2, '0');
          dEl.parentNode.hidden = days === 0;
        } else {
          hours += days * 24;
        }

        [['hours', hours], ['minutes', mins], ['seconds', secs]].forEach(function (pair) {
          var el = $('[data-unit="' + pair[0] + '"]', node);
          if (el) el.textContent = String(pair[1]).padStart(2, '0');
        });
      });
    }

    tick();
    countdownTimer = setInterval(tick, 1000);
  }

  /* -------------------------------------------- Estimación de entrega -- */

  var DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MONTH_NAMES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d, withMonth) {
    return DAY_NAMES[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' de ' + MONTH_NAMES[d.getMonth()] : '');
  }

  function initDeliveryEstimates() {
    $$('[data-delivery-estimate]').forEach(function (node) {
      var min = parseInt(node.dataset.deliveryMin || '5', 10);
      var max = parseInt(node.dataset.deliveryMax || '15', 10);
      var today = new Date();
      var from = addBusinessDays(today, min);
      var to = addBusinessDays(today, max);
      // Si los dos días caen en el mismo mes, no repetimos el mes dos veces.
      var sameMonth = from.getMonth() === to.getMonth();
      node.textContent = formatDate(from, !sameMonth) + ' y ' + formatDate(to, true);
    });
  }

  /* ----------------------------------------------------------- Cajones -- */

  var openDrawer = null;
  var lastFocused = null;

  function drawerOpen(id) {
    var drawer = document.getElementById(id);
    var overlay = $('#DrawerOverlay');
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    openDrawer = drawer;
    var focusable = drawer.querySelector('[data-drawer-close], button, a, input');
    if (focusable) focusable.focus();
  }

  function drawerClose() {
    var overlay = $('#DrawerOverlay');
    $$('.drawer').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  /* ------------------------------------------------------- Carrito AJAX -- */

  function updateCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    $$('[data-ship-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold || '0', 10);
      if (!threshold) return;
      var remaining = Math.max(0, threshold - cart.total_price);
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      var fill = $('[data-ship-fill]', bar);
      var text = $('[data-ship-text]', bar);
      if (fill) fill.style.width = pct + '%';
      if (!text) return;
      if (remaining === 0) {
        text.innerHTML = '<strong>' + escapeHtml(strings.shippingUnlocked || '¡Envío gratis conseguido!') + '</strong>';
      } else {
        text.innerHTML = escapeHtml(strings.shippingPrefix || 'Te faltan') +
          ' <strong>' + formatMoney(remaining) + '</strong> ' +
          escapeHtml(strings.shippingSuffix || 'para el envío gratis');
      }
    });

    renderDrawerContents(cart);
  }

  function renderDrawerContents(cart) {
    var body = $('[data-cart-drawer-body]');
    var foot = $('[data-cart-drawer-foot]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="drawer__empty"><p>' + escapeHtml(strings.cartEmpty || 'Tu cesta está vacía.') + '</p>' +
        '<a class="button" href="' + (T.routes.allProducts || '/collections/all') + '">' +
        escapeHtml(strings.keepShopping || 'Ver productos') + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? sizedImage(item.image, 160) : '';
      html += '<div class="cart-line" data-line-key="' + escapeHtml(item.key) + '">';
      html += img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">'
        : '<span class="cart-line__noimg" aria-hidden="true"></span>';
      html += '<div class="cart-line__body">';
      html += '<a class="cart-line__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>';
      if (item.variant_title) html += '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + '</div>';
      html += '<div class="price"><span class="price__current">' + formatMoney(item.final_line_price) + '</span>';
      if (item.original_line_price > item.final_line_price) {
        html += '<span class="price__compare">' + formatMoney(item.original_line_price) + '</span>';
      }
      html += '</div>';
      (item.line_level_discount_allocations || []).forEach(function (d) {
        html += '<div class="cart-line__discount">' + escapeHtml(d.discount_application.title) + '</div>';
      });
      html += '<div class="qty-row qty-row--line">';
      html += '<div class="qty-stepper"><button type="button" data-line-change="-1" aria-label="Quitar una unidad">&minus;</button>';
      html += '<input type="number" value="' + item.quantity + '" min="0" data-line-qty aria-label="Cantidad">';
      html += '<button type="button" data-line-change="1" aria-label="Añadir una unidad">+</button></div>';
      html += '<button type="button" class="cart-line__remove" data-line-remove>' + escapeHtml(strings.remove || 'Quitar') + '</button>';
      html += '</div></div></div>';
    });
    body.innerHTML = html;

    var total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(formData, opts) {
    opts = opts || {};
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || strings.addError || 'No se ha podido añadir el producto.');
          return null;
        }
        return fetchCart().then(function (cart) {
          updateCartUI(cart);
          if (opts.silent) {
            toast(strings.added || 'Añadido a la cesta');
          } else {
            drawerOpen('CartDrawer');
          }
          return cart;
        });
      })
      .catch(function () {
        toast(strings.addError || 'No se ha podido añadir el producto.');
        return null;
      });
  }

  function changeLine(key, quantity) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartUI(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      })
      .catch(function () { toast(strings.addError || 'No se ha podido actualizar la cesta.'); });
  }

  /* -------------------------------------------------- Galería producto -- */

  function galleryIndex(track) {
    var slides = $$('[data-gallery-slide]', track);
    if (!slides.length) return 0;
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    slides.forEach(function (slide, i) {
      var center = slide.offsetLeft + slide.offsetWidth / 2;
      var dist = Math.abs(center - mid);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function galleryGoTo(gallery, index, smooth) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $$('[data-gallery-slide]', track);
    if (!slides.length) return;
    index = Math.max(0, Math.min(slides.length - 1, index));
    track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    gallerySync(gallery, index);
  }

  function gallerySync(gallery, index) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $$('[data-gallery-slide]', track);
    if (typeof index !== 'number') index = galleryIndex(track);

    $$('[data-gallery-thumb]', gallery).forEach(function (thumb, i) {
      var active = i === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var counter = $('[data-gallery-counter]', gallery);
    if (counter) counter.innerHTML = (index + 1) + '&nbsp;/&nbsp;' + slides.length;

    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;

    // Un vídeo que sigue sonando fuera de pantalla es de las cosas que más
    // molestan en una ficha, así que se pausa al salir del hueco visible.
    slides.forEach(function (slide, i) {
      if (i === index) return;
      $$('video', slide).forEach(function (v) { if (!v.paused) v.pause(); });
    });
  }

  function initGalleries() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (!once(gallery, 'galleryInit')) return;
      var track = $('[data-gallery-track]', gallery);
      if (!track) return;

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          gallerySync(gallery);
          ticking = false;
        });
      }, { passive: true });

      $$('[data-gallery-thumb]', gallery).forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { galleryGoTo(gallery, i); });
      });

      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { galleryGoTo(gallery, galleryIndex(track) - 1); });
      if (next) next.addEventListener('click', function () { galleryGoTo(gallery, galleryIndex(track) + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); galleryGoTo(gallery, galleryIndex(track) + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); galleryGoTo(gallery, galleryIndex(track) - 1); }
      });

      // Colocar en la imagen de la variante que llega marcada en la URL.
      var startThumb = $('[data-gallery-thumb].is-active', gallery);
      if (startThumb) {
        var thumbs = $$('[data-gallery-thumb]', gallery);
        galleryGoTo(gallery, thumbs.indexOf(startThumb), false);
      } else {
        gallerySync(gallery, 0);
      }
    });
  }

  function galleryShowMedia(mediaId) {
    if (!mediaId) return;
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('[data-gallery-slide]', gallery);
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) {
          galleryGoTo(gallery, i);
          return;
        }
      }
    });
  }

  /* ------------------------------------------------------------- Zoom -- */

  function openZoom(src, alt) {
    var box = $('#Zoom');
    if (!box) {
      box = document.createElement('div');
      box.id = 'Zoom';
      box.className = 'zoom';
      box.innerHTML =
        '<button class="zoom__close" type="button" data-zoom-close aria-label="Cerrar">&times;</button>' +
        '<img class="zoom__image" alt="">';
      document.body.appendChild(box);
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('[data-zoom-close]')) closeZoom();
      });
    }
    var img = $('.zoom__image', box);
    img.src = src;
    img.alt = alt || '';
    box.classList.add('is-open');
    document.body.classList.add('is-locked');
    $('[data-zoom-close]', box).focus();
  }

  function closeZoom() {
    var box = $('#Zoom');
    if (!box) return;
    box.classList.remove('is-open');
    if (!openDrawer) document.body.classList.remove('is-locked');
  }

  /* --------------------------------------------------- Variantes producto -- */

  function initVariants() {
    $$('[data-variant-picker]').forEach(function (picker) {
      if (!once(picker, 'variantInit')) return;

      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var form = picker.closest('form');
      var scope = form || document;
      var idInput = form ? form.querySelector('[name="id"]') : $('[data-variant-id]');

      function chosen() {
        return $$('[data-option-input]:checked', picker).map(function (i) { return i.value; });
      }

      // Marca en gris las tallas o colores que no se pueden comprar con lo que
      // ya está elegido. Antes se podían seleccionar y el botón se quedaba en
      // «No disponible» sin explicar por qué.
      function paintAvailability() {
        var current = chosen();
        $$('.option-group', picker).forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          $$('.option-value', group).forEach(function (label) {
            var input = label.querySelector('input');
            if (!input) return;
            var ok = variants.some(function (v) {
              if (v.options[idx] !== input.value) return false;
              for (var j = 0; j < current.length; j++) {
                if (j !== idx && current[j] && v.options[j] !== current[j]) return false;
              }
              return v.available;
            });
            label.classList.toggle('is-unavailable', !ok);
            input.setAttribute('aria-disabled', ok ? 'false' : 'true');
          });
        });
      }

      function update() {
        var current = chosen();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var hit = true;
          for (var j = 0; j < current.length; j++) {
            if (v.options[j] !== current[j]) { hit = false; break; }
          }
          if (hit) { match = v; break; }
        }

        var button = $('[data-add-button]', scope) || $('[data-add-button]');
        var label = button ? $('[data-add-label]', button) : null;
        var stickyAdd = $('[data-sticky-add]');

        $$('.option-value', picker).forEach(function (el) {
          var input = el.querySelector('input');
          el.classList.toggle('is-selected', !!(input && input.checked));
        });
        $$('[data-option-selected]', picker).forEach(function (el) {
          var idx = parseInt(el.dataset.optionSelected, 10);
          el.textContent = current[idx] || '';
        });
        paintAvailability();

        if (!match) {
          if (button) button.disabled = true;
          if (label) label.textContent = strings.unavailable || 'No disponible';
          if (stickyAdd) stickyAdd.disabled = true;
          return;
        }

        if (idInput) idInput.value = match.id;

        if (button) button.disabled = !match.available;
        if (label) label.textContent = match.available ? (strings.addToCart || 'Añadir a la cesta') : (strings.soldOut || 'Agotado');
        if (stickyAdd) stickyAdd.disabled = !match.available;

        var wrap = $('[data-price-wrap]');
        if (wrap) {
          var onSale = match.compare_at_price && match.compare_at_price > match.price;
          var current$ = $('[data-price-current]', wrap);
          var compare$ = $('[data-price-compare]', wrap);
          var save$ = $('[data-price-save]', wrap);
          var saving$ = $('[data-price-saving]');

          if (current$) current$.textContent = formatMoney(match.price);
          if (compare$) {
            compare$.textContent = onSale ? formatMoney(match.compare_at_price) : '';
            compare$.hidden = !onSale;
          }
          if (save$) {
            save$.hidden = !onSale;
            if (onSale) save$.innerHTML = '&minus;' + Math.round((1 - match.price / match.compare_at_price) * 100) + '&nbsp;%';
          }
          if (saving$) {
            saving$.hidden = !onSale;
            if (onSale) {
              saving$.innerHTML = 'Te ahorras <strong>' + formatMoney(match.compare_at_price - match.price) + '</strong> · ';
            }
          }
          wrap.classList.toggle('price--on-sale', !!onSale);
        }

        var sku = $('[data-variant-sku]');
        if (sku && match.sku) sku.textContent = match.sku;
        var vTitle = $('[data-variant-title]');
        if (vTitle) vTitle.textContent = match.title;
        var stickyVariant = $('[data-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = match.title === 'Default Title' ? '' : match.title;
        var stickyImage = $('[data-sticky-image]');
        if (stickyImage && match.image) stickyImage.src = match.image;

        if (match.media_id) galleryShowMedia(match.media_id);

        if (form) form.dataset.unitPrice = match.price;
        $$('[data-bundle]').forEach(function (bundle) {
          bundle.dataset.unitPrice = match.price;
          renderBundle(bundle);
        });

        updateAddTotal();

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ------------------------------------------------- Packs por cantidad -- */

  function bundleUnitPrice(bundle) {
    return parseInt(bundle.dataset.unitPrice || '0', 10);
  }

  function renderBundle(bundle) {
    var unit = bundleUnitPrice(bundle);
    $$('[data-bundle-option]', bundle).forEach(function (option) {
      var qty = parseInt(option.dataset.bundleQty || '1', 10);
      var off = parseInt(option.dataset.bundleOff || '0', 10);
      var full = unit * qty;
      var total = Math.round(full * (1 - off / 100));

      var totalEl = $('[data-bundle-total]', option);
      var wasEl = $('[data-bundle-was]', option);
      var unitEl = $('[data-bundle-unit]', option);

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (wasEl) wasEl.textContent = off > 0 ? formatMoney(full) : '';
      if (unitEl) unitEl.textContent = qty > 1 ? formatMoney(Math.round(total / qty)) + ' / ud.' : '';
    });
  }

  function selectBundle(bundle, option, syncQty) {
    $$('[data-bundle-option]', bundle).forEach(function (o) {
      var active = o === option;
      o.classList.toggle('is-selected', active);
      var input = o.querySelector('input');
      if (input) input.checked = active;
    });

    if (syncQty === false) return;
    var form = bundle.closest('form');
    var qtyInput = form ? form.querySelector('[data-qty-input]') : null;
    if (qtyInput && option) {
      qtyInput.value = option.dataset.bundleQty || '1';
      updateAddTotal();
    }
  }

  // El puente que faltaba: si tocas el selector de unidades, el pack marcado
  // se ajusta o se desmarca en vez de quedarse mintiendo.
  function syncBundleToQuantity(form) {
    var bundle = form ? form.querySelector('[data-bundle]') : null;
    var qtyInput = form ? form.querySelector('[data-qty-input]') : null;
    if (!bundle || !qtyInput) return;

    var qty = parseInt(qtyInput.value, 10) || 1;
    var hit = $$('[data-bundle-option]', bundle).filter(function (o) {
      return parseInt(o.dataset.bundleQty, 10) === qty;
    })[0];

    if (hit) {
      selectBundle(bundle, hit, false);
      bundle.classList.remove('is-custom');
    } else {
      $$('[data-bundle-option]', bundle).forEach(function (o) {
        o.classList.remove('is-selected');
        var input = o.querySelector('input');
        if (input) input.checked = false;
      });
      bundle.classList.add('is-custom');
    }
  }

  function initBundles() {
    $$('[data-bundle]').forEach(function (bundle) {
      renderBundle(bundle);
      if (!once(bundle, 'bundleInit')) return;

      var checked = $('[data-bundle-option] input:checked', bundle);
      var start = checked ? checked.closest('[data-bundle-option]') : $('[data-bundle-option]', bundle);
      if (start) selectBundle(bundle, start);

      bundle.addEventListener('click', function (e) {
        var option = e.target.closest('[data-bundle-option]');
        if (!option) return;
        bundle.classList.remove('is-custom');
        selectBundle(bundle, option);
      });
    });
  }

  /* -------------------------------------- Total del botón de la cesta -- */

  function updateAddTotal() {
    var form = $('#ProductForm') || $('.product-form');
    if (!form) return;

    var button = $('[data-add-button]', form) || $('[data-add-button]');
    var totalEl = button ? $('[data-add-total]', button) : null;
    if (!totalEl) return;

    var qty = parseInt((form.querySelector('[data-qty-input]') || {}).value, 10) || 1;
    var bundle = form.querySelector('[data-bundle]');
    var unit = bundle ? bundleUnitPrice(bundle) : 0;

    // El precio unitario en céntimos lo escribe Liquid en el formulario y lo
    // actualiza el selector de variantes. Nada de leer el texto ya formateado:
    // eso se rompía con cualquier formato de moneda que no fuera el español.
    if (!unit) unit = parseInt(form.dataset.unitPrice || '0', 10);
    if (!unit) { totalEl.textContent = ''; return; }

    var off = 0;
    var selected = bundle ? $('[data-bundle-option].is-selected', bundle) : null;
    if (selected && parseInt(selected.dataset.bundleQty, 10) === qty) {
      off = parseInt(selected.dataset.bundleOff || '0', 10);
    }

    var total = Math.round(unit * qty * (1 - off / 100));
    totalEl.textContent = qty > 1 ? '· ' + formatMoney(total) : '';

    var stickyPrice = $('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(total);
  }

  /* ---------------------------------------------------------- Acordeón -- */

  function initAccordion() {
    $$('.accordion__trigger').forEach(function (trigger) {
      if (!once(trigger, 'accordionInit')) return;
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ------------------------------------------------- Barra fija producto -- */

  var stickyObserver = null;

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor) return;
    if (stickyObserver) stickyObserver.disconnect();

    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });

    stickyObserver.observe(anchor);
  }

  /* ------------------------------------------------------------ Compartir -- */

  function initShare() {
    $$('[data-share]').forEach(function (btn) {
      if (!once(btn, 'shareInit')) return;
      btn.addEventListener('click', function () {
        var url = btn.dataset.shareUrl || window.location.href;
        var title = btn.dataset.shareTitle || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado'); });
        }
      });
    });
  }

  /* ---------------------------------------------------------- Revelado -- */

  function initReveal() {
    var items = $$('.reveal:not([data-reveal-init])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (i) { i.dataset.revealInit = 'on'; obs.observe(i); });
  }

  /* ------------------------------------------------------- Recomendaciones -- */

  // En el render normal de la página, `recommendations.products` viene vacío:
  // Shopify solo lo rellena cuando la sección se pide por su endpoint. La
  // sección ya pinta un respaldo con la colección del producto, y aquí lo
  // cambiamos por las recomendaciones reales en cuanto llegan.
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (section) {
      if (!once(section, 'recsInit')) return;
      var url = section.dataset.url;
      if (!url) return;

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.product-grid');
          var current = $('.product-grid', section);
          if (!fresh || !current) return;
          if (!fresh.querySelector('.product-card')) return;
          current.innerHTML = fresh.innerHTML;
          initReveal();
        })
        .catch(function () { /* se queda el respaldo, que ya es válido */ });
    });
  }

  /* ---------------------------------------------------- Orden colección -- */

  function initCollectionSort() {
    $$('[data-sort-by]').forEach(function (select) {
      if (!once(select, 'sortInit')) return;
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* --------------------------------------- Listeners globales (una vez) -- */

  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    // Cajones
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        drawerOpen(opener.dataset.drawerOpen);
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.id === 'DrawerOverlay') {
        e.preventDefault();
        drawerClose();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var zoom = $('#Zoom');
      if (zoom && zoom.classList.contains('is-open')) { closeZoom(); return; }
      if (openDrawer) drawerClose();
    });

    // Ampliar imagen
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-open]');
      if (!trigger) return;
      e.preventDefault();
      openZoom(trigger.dataset.zoomSrc, trigger.dataset.zoomAlt);
    });

    // Añadir a la cesta desde cualquier formulario de producto
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('[type="submit"]:not([form])') || form.querySelector('[type="submit"]');
      var label = button ? (button.querySelector('[data-add-label]') || button) : null;
      var original = label ? label.textContent : '';
      var sticky = $('[data-sticky-add]');

      if (button) button.disabled = true;
      if (sticky) sticky.disabled = true;
      if (label) label.textContent = strings.adding || 'Añadiendo…';

      addToCart(new FormData(form), { silent: form.classList.contains('quick-add-form') })
        .then(function () {
          if (button) button.disabled = false;
          if (sticky) sticky.disabled = false;
          if (label) label.textContent = original;
        });
    });

    // Cantidad: pasos + y −
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var input = btn.parentNode.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyChange, 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Cantidad escrita a mano en la ficha
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      if ((parseInt(input.value, 10) || 0) < min) input.value = min;
      syncBundleToQuantity(input.closest('form'));
      updateAddTotal();
    });

    // Líneas de la cesta
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var changeBtn = e.target.closest('[data-line-change]');
      var removeBtn = e.target.closest('[data-line-remove]');
      if (!changeBtn && !removeBtn) return;

      var input = $('[data-line-qty]', line);
      if (removeBtn) { changeLine(line.dataset.lineKey, 0); return; }
      if (changeBtn && input) {
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(changeBtn.dataset.lineChange, 10));
        changeLine(line.dataset.lineKey, next);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      var line = input.closest('[data-line-key]');
      if (line) changeLine(line.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  /* -------------------------------------------------------------- Init -- */

  function init() {
    bindGlobals();
    initAnnouncement();
    initCountdowns();
    initDeliveryEstimates();
    initGalleries();
    initVariants();
    initBundles();
    initAccordion();
    initStickyAtc();
    initShare();
    initReveal();
    initCollectionSort();
    initRecommendations();
    updateAddTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
  });
})();
